// extracted by mini-css-extract-plugin
module.exports = {"icon":"Engine_icon__1EbUF"};